<template>
  <div class="wdw-forum-edit-thought" :class="'topic-' + topic.id + ' thought-' + thought.id">
    <template v-if="!topic">
      <loading loadingMessage="Formular wird geladen..." />
    </template>

    <template v-else>
      <template v-if="showForm">
        <wdw-dynbox>
          <thought-form
            :thoughtid="thought.id"
            :topic="topic"
            @feedback-thought="onFeedbackFromCreate"
            @cancel-thought-form="cancelThoughtForm"
            labelTitle="Überschrift des Themas"
            labelDescription="Beschreibung"
          />
        </wdw-dynbox>
      </template>
      <template v-else>
        <p>Fehler, bitte Loggen Sie sich zunächst ein</p>
      </template>
    </template>
  </div>
</template>

<script>
import { onBeforeMount, computed, toRef } from 'vue';

// components
import Loading from '@/components/general/Loading.vue';
import ThoughtForm from '@/components/discuss/thought/Form.vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';

// composables
import useThoughtConfig from '@/composables/thought/useThoughtConfig';

export default {
  name: 'forum-edit-thought',
  props: {
    topic: {
      type: Object,
      required: true,
    },
    thought: {
      type: Object,
      required: true,
    },
  },
  emits: ['show-thought', 'show-topic', 'push-message', 'clear-messages'],
  setup(props, context) {
    const topic = toRef(props, 'topic');
    const thought = toRef(props, 'thought');

    const { canEditThought } = useThoughtConfig();

    //
    //-----------------COMPUTED------------------
    //

    const showForm = computed(() => {
      return topic.value && canEditThought(thought.value);
    });

    //
    //-----------------METHODS------------------
    //
    function cancelThoughtForm() {
      context.emit('show-thought', {
        thoughtid: thought.value.id,
        name: thought.value.title,
      });
    }
    function onFeedbackFromCreate(feedback) {
      //new thought was created, go back to list view
      if (feedback.thought && feedback.thought.status === 'show') {
        context.emit('show-thought', {
          thoughtid: feedback.thought.id,
          name: feedback.thought.title,
        });
      } else {
        context.emit('show-topic', {
          topicid: topic.value.id,
          name: topic.value.title,
        });
      }
      context.emit('push-message', {
        severity: feedback.type,
        content: feedback.message,
      });
    }

    // initialization
    onBeforeMount(() => {
      // reset any messages on new thought
      context.emit('clear-messages');
    });

    return {
      // REFS

      // COMPUTED
      showForm,

      // METHODS
      cancelThoughtForm,
      onFeedbackFromCreate,
    };
  },

  components: {
    Loading,
    ThoughtForm,
    WdwDynbox,
  },
};
</script>
